module.exports = __webpack_public_path__ + "img/multi_image08.bebc1fb6.png";